const MONITORABLE_VIEW_TYPE_STORAGE_KEY = "monitorableCurrentViewType";
define([
    "./monitorableModule",
    "json!../tdnByEntity.json",
], function (monitorableModule, tdnByEntity) {
    "use strict";

    const NodeTypes = {
        TRIP: "Trip",
        LOAD: "Load",
        INVOICE: "Invoice",
        DOCUMENT: "Document",
        TRANSITION: "Transition",
    };

    return monitorableModule.controller("MonitorableSearchController", [
        "$scope",
        "monitoringService",
        "monitorableService",
        "transitionService",
        "monitoringBasketService",
        "transitionSpreadsheetService",
        "transitionFailureReasonModal",
        "mbrService",
        "tdnHelp",
        "monitoringUserPreferencesService",
        "attachmentMandatoryModal",
        function ($scope, monitoringService, monitorableService, transitionService, monitoringBasketService, transitionSpreadsheetService, transitionFailureReasonModal, mbrService, tdnHelp, monitoringUserPreferencesService, attachmentMandatoryModal) {
            $scope.tdn = tdnByEntity?.[tdnHelp.getContext()]?.["monitorable-search"];
            const defaultView = {
                keyBundle: "monitoring.viewTypes.destinationView",
                monitoringBasketServiceUrl: "monitorable/by-destination",
            };
            let userView = monitoringUserPreferencesService.getPreferencesOrDefault(defaultView);

            $scope.viewType = {
                currentView: userView,
                possibleViews: {
                    "MONITORABLE_VIEW": {
                        keyBundle: "monitoring.viewTypes.monitorableView",
                        monitoringBasketServiceUrl: "monitorable",
                    },
                    "DESTINATION_VIEW": defaultView,
                    "TEMPERATURE_VIEW": {
                        keyBundle: "monitoring.viewTypes.temperatureView",
                        monitoringBasketServiceUrl: "monitorable/by-temperature",
                    }
                }
            };

            $scope.changeViewType = function (type) {
                monitoringUserPreferencesService.savePreferences(type)
                $scope.viewType.currentView = type
            }

            $scope.basket = {
                monitoringBasketService: monitoringBasketService,
                selection: {},
                api: null
            };

            $scope.onRegisterBasketApi = function (api) {
                $scope.basket.api = api;
            };

            $scope.hasMonitorableSelection = function () {
                return getSelectedMonitorables().length;
            };

            $scope.finishMonitorables = function () {
                return modifyNodesAndRefresh(getSelectedMonitorables(), monitorableService.finishMonitorables);
            };

            $scope.startMonitorables = function () {
                return modifyNodesAndRefresh(getSelectedMonitorables(), monitorableService.startMonitorables);
            };

            $scope.updateMonitorablesConfigs = function () {
                return modifyNodesAndRefresh(getSelectedMonitorables(), monitorableService.updateMonitorablesConfigs);
            };

            $scope.cancelMonitorables = function () {
                return modifyNodesAndRefresh(getSelectedMonitorables(), monitorableService.cancelMonitorables);
            };

            $scope.hasTransitionSelection = function () {
                return getSelectionType(NodeTypes.TRANSITION).length;
            };

            $scope.finalizeTransitions = function () {
                return finalizeTransitions(getSelectionType(NodeTypes.TRANSITION), transitionService.accomplishTransitions);
            };

            $scope.isDisabledInvoiceTransitions = function () {
                const selectedTransitionNodes = $scope.basket.selection[NodeTypes.TRANSITION];
                if (!selectedTransitionNodes) {
                    return true;
                }
                if (selectedTransitionNodes.length === 1) {
                    return false;
                }
                let invoiceTransitions = selectedTransitionNodes.filter(selectedTransitionNode => {
                    return selectedTransitionNode.type.monitorableNodeType === NodeTypes.INVOICE.toUpperCase();
                });
                return invoiceTransitions.length > 1;
            };

            $scope.notAccomplishTransitions = function () {
                if ($scope.isDisabledInvoiceTransitions()) {
                    return;
                }
                const selections = getSelectionType(NodeTypes.TRANSITION).map((node) => node.id);
                const invoiceNodes = getSelectionType(NodeTypes.INVOICE);
                const selectedTransitionNodes = $scope.basket.selection[NodeTypes.TRANSITION];
                transitionFailureReasonModal(selections, null, null, invoiceNodes, selectedTransitionNodes).then(() => $scope.basket.api.refreshFilter());
            };

            $scope.openImportModal = function () {
                return transitionSpreadsheetService.openImportModal().then($scope.reload);
            };

            $scope.downloadAttachments = function () {
                var selectionTripId = getSelectionType(NodeTypes.TRIP).map((node) => node.id);
                if (selectionTripId.length > 0) {
                    mbrService.downloadAllMonitorablesAttachments(getSelectionType(NodeTypes.TRIP).map((node) => node.id));
                }
            }

            $scope.hasTripSelection = function () {
                return getSelectionType(NodeTypes.TRIP).length;
            };

            function getSelectedMonitorables() {
                return getSelectionType(NodeTypes.TRIP)
                    .concat(getSelectionType(NodeTypes.LOAD))
                    .concat(getSelectionType(NodeTypes.INVOICE))
                    .concat(getSelectionType(NodeTypes.DOCUMENT));
            }

            function getSelectionType(type) {
                return $scope.basket.selection[type] || [];
            }

            function modifyNodesAndRefresh(nodes, modifier) {
                return modifier(nodes.map(node => node.id)).then(() => $scope.basket.api.refreshFilter());
            }


            function finalizeTransitions(nodes, modifier) {
                if (nodes.length === 1 && nodes[0].type.monitorableNodeType === "INVOICE") {
                    return transitionService.isAttachmentRequired().then(function (isAttachmentRequired) {
                        if (isAttachmentRequired) {
                            return attachmentMandatoryModal(nodes[0].id)
                                .then(function () {
                                    return $scope.basket.api.refreshFilter();
                                });
                        }
                        return executeFinalize(modifier, nodes);
                    })
                }
                return executeFinalize(modifier, nodes);
            }

            function executeFinalize(modifier, nodes) {
                return modifier(nodes.map(node => node.id)).then(() => $scope.basket.api.refreshFilter());
            }
        }]);
});
